<!--  -->
<template>
  <div id="div_footer">
  <a target="_blank" title="51la网站统计" href="https://v6.51.la/s/i9U5x7dXhrBxwJ4"><img style="position: relative; top: 4px;" src="https://sdk.51.la/icon/3-1.png"></a> 版权所有  北京爱如生数字化技术研究中心  copyright ©2026 Beijing Erudition Digital Technology Research Center
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
#div_footer {
  height: 30px;
  width: 100%;
  font-size: 14px;
  color: #fff;
}
</style>
